<template>
  <div>
    <div class="layout-header" ref="searchBox">
      <div class="infor-layout-header">
        <span class="title">站点同步</span>
      </div>
      <el-form
        :inline="true"
        :model="copy"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="品牌：">
          <el-select v-model="copy.brandId" placeholder="请选择品牌">
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in brands"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期：">
          <el-date-picker
            v-model="copy.dataRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="check">查询</el-button>
          <el-button type="primary" @click="refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="height: 165px"></div>
    <div class="pagination-bg-white layout-header">
      <w-table
        width="100%"
        v-show="checkUserAuth(4, 14)"
        v-loading.body="tableLoading"
        :bPagination="false"
        :height="tableViewHeight"
        :data-list="tabledata"
        :columns="columns"
      >
        <template slot-scope="{ text }" slot="cell">
          <span>{{ text }}</span>
        </template>
      </w-table>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
import WTable from '@/components/Table/index.vue'
export default {
  name: 'sitesync',
  components: {
    WTable
  },
  data() {
    return {
      copy: {},
      form: {},
      tableViewHeight: '',
      columns: [
        {
          prop: 'brand_name',
          label: '品牌'
        },
        {
          prop: 'create_time',
          label: '日期'
        }
      ],
      tableLoading: true,
      tabledata: []
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userLevel', 'brands'])
  },
  created() {
    // if (this.userLevel !== 2) {
    //   let path = '/CompanyManagement/company/'
    //   if (this.selfAreaId) {
    //     path += this.selfAreaId
    //   }
    //   this.$router.push(path)
    //   return
    // }
    this.refresh()
  },
  methods: {
    check() {
      this.form = { ...this.copy }
      this.getData()
    },
    refresh() {
      this.form = {
        dataRange: [this.dayjs().startOf('M').format('YYYY-MM-DD HH:mm:ss'),
          this.dayjs().endOf('M').format('YYYY-MM-DD HH:mm:ss')]
      }
      this.copy = { ...this.form }
      this.getData()
    },
    getData() {
      this.tableLoading = true
      const postdata = {
        selfAreaId: this.selfAreaId
      }
      if (this.form.brandId) {
        postdata.brandId = this.form.brandId
      }
      if (this.form.dataRange) {
        postdata.startTime = this.form.dataRange[0]
        postdata.endTime = this.form.dataRange[1]
      }
      Api.getSyncSiteLog(postdata).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tabledata = res.data
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    },
    onEdit(data) {
      this.$refs['w-dialog'].onShowDialog()
    },
    onSure3() {
      this.handleClose3()
    },
    handleClose3() {
      this.formLabelAlign = {}
      this.$refs['w-dialog'].onCloseDialog()
    }
  }
}
</script>

<style lang="less">
.layout-header {
  margin: 16px;
  width: calc(98% - 20px);
}

.demo-form-inline{
  margin-top: 24px;
}
</style>
